export default __webpack_public_path__ + "static/media/accomm_img_11.6d10c54c.JPG";